import { MarketingShell } from './MarketingShell'
import { AdminCustomerSegments } from './AdminCustomerSegments'

export function AdminSegmentsPage() {
  return (
    <MarketingShell
      title="Segments"
      description="Saved audience queries — birthdays this month, lapsed, at risk, VIPs, first-timers, regulars. Preview, export to CSV, or feed straight into campaigns."
    >
      <AdminCustomerSegments />
    </MarketingShell>
  )
}
